import { gql } from '@apollo/client';

export type {
  GetLogs as IGetLogs,
  GetLogs_getLogs_logs as ILogData,
  GetLogsVariables as IGetLogsVariables,
} from './__generated__/GetLogs';

export const GET_LOGS = gql`
  query GetLogs($cursor: String, $errorsOnly: Boolean) {
    getLogs(cursor: $cursor, errorsOnly: $errorsOnly) {
      logs {
        agent
        method
        operationType
        origin
        requestBody
        responseBody
        statusCode
        timestamp
        path
      }
      cursor
    }
  }
`;
